<div class="fixed-min-header-height pt-3 pt-md-4 pt-lg-0 grey-bg">
  <div class="container-fluid product-lisitng-wrapper cart-lisitng-wrapper">
    <div class="row">
      <div class="col-12">
        <a [routerLink]="['/mycart/']" title="back" class="back-listing-btn d-none d-lg-block back-cart" href="javascript:void(0);">
          <svg width="15px" height="16px" viewBox="0 0 15 16" version="1.1" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <title>Combined Shape</title>
            <desc>Created with Sketch.</desc>
            <g id="SCREENS" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="210209_shopboss_cart" transform="translate(-1719.000000, -1333.000000)" fill="#D9394C"
                fill-rule="nonzero">
                <path
                  d="M1726.46967,1333.46967 L1727.53033,1334.53033 L1721.811,1340.24967 L1734,1340.25 L1734,1341.75 L1721.811,1341.74967 L1727.53033,1347.46967 L1726.46967,1348.53033 L1719.46967,1341.53033 C1719.2034,1341.26406 1719.1792,1340.8474 1719.39705,1340.55379 L1719.46967,1340.46967 L1726.46967,1333.46967 Z"
                  id="Combined-Shape"></path>
              </g>
            </g>
          </svg> Back </a>
      </div>
    </div>
    <div class="row">
      <div class="col-12 fixed-width-right-column">
        <div class="payment-container " >
          <div class="new-card-payment first">
            <div class="payment-box" >
              <p >Pay with a new card</p>
              <div class="input-box">
                <label>Enter Card Details</label>
                <div id="flow-container"></div>
                <!-- YOUR CUSTOM YELLOW ANGULAR PAY BUTTON -->
                <div class="custom-angular-action-block" *ngIf="isFormRendered">
                  <button id="custom-pay-now-btn"
                          type="button"
                          class="newcard-payment"
                          [disabled]="isPaymentLoading"
                          (click)="$event.preventDefault(); submitPayment(errorTemplate)">
                    
                    <span *ngIf="!isPaymentLoading">
                      PAY £ {{orderDetail?.cart_total?.grand_total}}
                    </span>
                
                    <span *ngIf="isPaymentLoading">
                      Processing...
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <input id='card-token' value=''>
        <input id='card-bin' value=''>
      </div>
      
      <div class="col-12 fixed-width-left-column" *ngIf='orderDetail != null'>
        <div class="quick-add-box order-details">
          <h3>Order Summary</h3>
          <div class="product-detail">
            <ul>
              <li>
                <p *ngIf="orderDetail.items_count == '1'">Item</p>
                <p *ngIf="orderDetail.items_count != '1'">Items</p>
                <span>{{orderDetail.items_count}}</span>
              </li>
              <li>
                <p *ngIf="orderDetail.items_qty == '1'">Case</p>
                <p *ngIf="orderDetail.items_qty != '1'">Cases</p>
                <span>{{orderDetail.items_qty}}</span>
              </li>
              <li>
                <p>Net Amount:</p><span>£{{orderDetail?.cart_total?.subtotal}}</span>
              </li>
            </ul>
          </div>
          <div class="promotion-listing" *ngIf='orderDetail?.promotions?.length != 0'>
            <h5>
              Promotion:
            </h5>
            <ul>
              <li  *ngFor="let pro of orderDetail.promotions">
                <p>{{pro.name}}</p><span class="red">- £{{pro.discount}}</span>
              </li>
            </ul>
          </div>
          <div class="promotion-listing discount" *ngIf="(orderDetail?.cart_total.store_discount != '' && orderDetail.cart_total.store_discount >  0)">
            <h5>
              Discount Applied:
            </h5>
            <span class="red">- £{{orderDetail['cart_total']?.store_discount}}</span>
          </div>
          <div class="promotion-listing discount" *ngIf="global_data?.price_visibility == 1 && global_data?.vat_exempt == 0">
            <h5>
              VAT:
            </h5>
            <span>£{{orderDetail.cart_total.vat}}</span>
          </div>
          <div class="promotion-listing discount total">
            <h5>
              Total Amount:
            </h5>
            <span>£{{orderDetail?.cart_total?.grand_total}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #errorTemplate>
  <div class="modal-header border-0 pb-2 align-items-center">
      <h4 class="modal-title">Error</h4>
  </div>
  <div class="modal-body py-0 px-0">
    <div class="row">
      <div class="col-md-12">
        <div class="text-center">
          <p>{{errorMessage}} </p>
        </div>
        <div class="button-div text-center mt-3 align-items-center">
          <button class="common-button mr-3 error-btn" (click)="closeErrorPopup()">Refresh Now</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #infoTemplate>
  <div class="modal-header border-0 pb-2 align-items-center">
      <h4 class="modal-title">Info</h4>
  </div>
  <div class="modal-body py-0 px-0">
    <div class="row">
      <div class="col-md-12">
        <div class="text-center">
          <p>We are redirecting you to the payment gateway screen, do not refresh or close the window till the order gets complete.Also, please make sure that new pop window is enabled for your browser to complete the order.</p>
        </div>
        <div class="button-div text-center mt-3 align-items-center">
          <button class="common-button mr-3 error-btn" (click)="closeInfoPopup()">Ok</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>